export const CustomFr = {
  TITLE: "Code",
  BLOCKS: "Blocs",
  LINKTOOLTIP: "Sauvegarder et lier aux blocs.",
  RUNTOOLTIP:
    "Lancer le programme défini par les blocs dans l’espace de travail.",
  BADCODE: "Erreur du programme :\n%1",
  TIMEOUT: "Nombre maximum d’itérations d’exécution dépassé.",
  TRASHTOOLTIP: "Jeter tous les blocs.",
  CATLOGIC: "Logique",
  CATLOOPS: "Boucle",
  CATMATH: "Math",
  CATALGEBRA: "Algèbre",
  CATANALYSIS: "Analyse",
  CATARITHMETIC: "Arithmétique",
  CATGEOMETRY: "Géométrie",
  CATMATRIX: "Matrices",
  CATSTATS: "Stats",
  CATLANG: "Lang",
  CATFRENCH: "Français",
  CATTEXT: "Texte",
  CATLISTS: "Liste",
  CATCOLOUR: "Couleur",
  CATVARIABLES: "Variable",
  CATFUNCTIONS: "Procédure",
  CATMEDIA: "Média",
  LISTVARIABLE: "liste",
  TEXTVARIABLE: "texte",
  HTTPREQUESTERROR: "Il y a eu un problème avec la demande.",
  LINKALERT: "Partagez vos blocs grâce à ce lien:\n\n%1",
  HASHERROR: "Désolé, '%1' ne correspond à aucun programme sauvegardé.",
  XMLERROR:
    "Impossible de charger le fichier de sauvegarde.  Peut-être a-t-il été créé avec une autre version de Blockly?",
  BADXML:
    "Erreur d’analyse du XML :\n%1\n\nSélectionner 'OK' pour abandonner vos modifications ou 'Annuler' pour continuer à modifier le XML.",
  CATEXAMPLES: "Introduction",
  CATSTART: "Démarrage",
  CATDISPLAY: "Affichage",
  CATQUESTIONS: "Question",
  CATAI: "IA",
  CATFEEDBACK: "Rétroactions",

  CATOBJECTS: "Objets",
  //LABEL SEPARATORS
  LABEL_START: "Démarrage",
  LABEL_FORMATTING: "Mise en forme",
  LABEL_STYLES: "Styles",
  LABEL_EXPERT: "Expert",

  LABEL_NUMBERS: "Nombres",
  LABEL_CALCULUS: "Calcul",
  LABEL_ARITHMETICS: "Arithmetique",
  LABEL_FRACTIONS: "Fractions",
  LABEL_UNITS: "Unités",

  LABEL_FUNCTIONS: "Fonctions",
  LABEL_TOOLS: "Outils",
  LABEL_GRAPHIC: "Graphique",

  LABEL_OBJECTS: "Objets",
  LABEL_TRANSFORMATIONS: "Transformations",
  LABEL_CALCULUSES: "Calculs",
  LABEL_DISPLAY: "Affichage",

  LABEL_LIST_EXPERT: "Expert",
  LABEL_MATRIX_EXPERT: "Expert",

  //EXAMPLES CAT
  EXAMPLES_PRINCIPLE_TITLE: "Principe général de construction",
  EXAMPLES_PRINCIPLE_DOCUMENTATION: `La conception d'une activité de base se réalise avec 3 blocs principaux :
- 1 : Un bloc entête au début de l'activité
- 2 : Un bloc Enoncé en dessous avec un bloc affiche pour afficher votre énoncé
- 3 : Un ou plusieurs blocs Questions
La plupart des blocs disposent de champs préremplis par des blocs ou valeurs par défaut. Ceci dans l'objectif de vous guider dans la construction de votre activité. Bien entendu, ces champs peuvent être remplacés par d'autres types de blocs.`,

  //WORKSPACE
  DOWNLOAD_SCREENSHOT: "Télécharger une copie d'écran",
  DELETE_UNUSED_VARIABLES: "Supprimer les variables inutilisées",

  //START CAT
  //BLOCK INFO
  INFO_TITLE: "Activité",
  INFO_MESSAGE:
    "Activité titre %1 langue %2 description %3 tentatives max%4 rétroaction par défaut%5",
  INFO_LANG_TOOLTIP: `Tapez le code langue à deux lettres (exemples : "fr" pour francais, "en" pour anglais...)`,
  INFO_TOOLTIP: `Le bloc Entête d'une activité. Il doit être placé au début de l'activité.
    - titre : titre de l'activité.
    - description : courte description de l'activité.
    - Rétroaction par défaut : correspond à une rétroaction automatique et globale à l'activité. Il est principalement utile lorsque l'activité intègre plusieurs questions. Dans ce cas, la rétroaction indiquera la réussite à toutes les questions ou l'échec à moins une des question.`,
  INFO_COMMENT:
    "Commentez ici le fonctionnement de votre code pour aider les autres à le comprendre et à l'adapter.",
  //LANG
  LANG_MATRIX_TITLE: "Activité (Multilingue)",
  LANG_MATRIX_DEFAULT_FEEDBACK: "rétroaction par défaut",
  LANG_MATRIX_MAX_ATTEMPTS: "tentatives max",
  LANG_MATRIX_ACTIVITY_TITLE: "TITRE               ",
  LANG_MATRIX_DESCRIPTION: "DESCRIPTION",
  LANG_MATRIX_LANG: "LANGUE          ",
  LANG_MATRIX_KEY: "KEY",
  LANG_MATRIX_DEFAULT_TEXT: "Texte",
  LANG_MATRIX_CODE: "",
  LANG_MATRIX_TOOLTIP: `Tableau permettant de concevoir des activités en plusieurs langues.
  Il est placé à part et au-dessus des autres blocs dans l'espace de conception pour être chargé en premier.
  Chaque ligne contient un mot clé suivi de ses traductions dans chaque colonne.
  Chaque colonne correspond à un code langue. La première colonne correspond à la langue par défaut.
  Eleda détecte automatiquement la langue du navigateur et affichera le mot ou la phrase correspondant au mot clé
  `,

  //LANG_TEXT
  LANG_TEXT_TITLE: "Texte multilingue",
  LANG_TEXT_MESSAGE: "texte ayant pour clef %1",
  LANG_TEXT_NOTFOUND: "ref non trouvée",
  LANG_TEXT_TOOLTIP:
    "Renvoie la chaine de caractères correspondant à la clef et la langue définie par le navigateur",

  //BLOCK STATEMENT
  STATEMENT_TITLE: "Énoncé",
  STATEMENT_MESSAGE: "Énoncé %1",
  STATEMENT_TOOLTIP: `Contient l'ensemble des éléments à afficher dans l'énoncé.
    Contient le plus souvent des blocs "Affiche".`,
  //BLOCK DISPLAY_ELEMENT
  DISPLAY_ELEMENT_TITLE: "Afficher",
  DISPLAY_ELEMENT_MESSAGE: "afficher %1",
  DISPLAY_ELEMENT_LEFT_ALIGN: "aligné à gauche",
  DISPLAY_ELEMENT_CENTER_ALIGN: "centré",
  DISPLAY_ELEMENT_RIGHT_ALIGN: "aligné à droite",
  DISPLAY_ELEMENT_JUSTIFY_ALIGN: "justifié",
  DISPLAY_ELEMENT_TOOLTIP: `Permet d'afficher des éléments dans un "Énoncé".
    Inclus le plus souvent dans le bloc "Enoncé". 
    Contient des blocs de tout type : figures géométriques, math, grapiques, textes ...
    Dans le cas où il contient des élements géométriques, il sera réalisé dans un graphique par défaut ayant pour bornes Xmin:0, Ymax:10, Xmax:10, Ymin:0.
    Il permet également durant la phase de conception de vérifier rapidement les différentes valeurs et variables de l'activité (débogage)`,
  //PARAGRAPH (RICHTEXT)
  RICHTEXT_CREATE_WITH_TITLE: "paragraphe",
  RICHTEXT_CREATE_WITH_INPUT_WITH: "créer un paragraphe avec ",
  RICHTEXT_CREATE_WITH_TOOLTIP: `Permet de combiner des éléments en vue de les afficher les uns à la suite des autres dans un paragraphe.
    Renvoie un paragraphe avec une suite liste d'objets à afficher.
    Inclus le plus souvent dans un bloc "Affiche".
    Contient le plus souvent des blocs de type "Texte", "LaTeX", "Markdown", "Géométrie", "Question en affichage imbriqué".`,

  //LATEX_PARAGRAPH (RICHTEXT)
  LATEX_PARAGRAPH_CREATE_WITH_TITLE: "Assemblage LaTeX",
  LATEX_PARAGRAPH_CREATE_WITH_INPUT_WITH: "créer un assemblage LaTeX avec ",
  LATEX_PARAGRAPH_CREATE_WITH_TOOLTIP: `Permet d'assembler du code LaTeX avec des blocs Eleda en vue de les afficher de manière imbriquée.
    Renvoie un assemblage LateX prêt à être affiché.
    Inclus le plus souvent dans un bloc "Affiche".
    Contient le plus souvent des blocs de type "Texte" (contenant des chaînes LaTeX), "Question en affichage imbriqué", "Géométrie",.`,

  //ALIGNMENT  COLOUR RANDOM_COLOUR SIZE
  SET_ALIGNMENT_TOOLTIP:
    "Aligne le bloc contenu à gauche, au centre ou à droite. Contient le plus souvent un bloc paragraphe.",
  SET_COLOUR_TOOLTIP:
    "Applique une couleur à un bloc. Ce bloc peut être appliqué à de nombreux blocs différents (texte, géométrie etc).",
  SET_COLOUR_RANDOM_TOOLTIP:
    "Applique une couleur aléatoire à un bloc. Ce bloc peut être appliqué à de nombreux blocs différents (texte, géométrie etc).",
  SET_SIZE_TOOLTIP:
    "Applique une taille à un bloc. Ce bloc peut être appliqué à de nombreux blocs différents (texte, question, géométrie etc).",
  SET_ATTRIBUTE_MESSAGE: "paramétrer %1 avec %2",
  SET_ATTRIBUTE_TOOLTIP:
    "Avancé : Ce bloc permet d'appliquer des paramètres spécifiques à certains blocs (cf Documentation)",
  SET_ATTRIBUTE_DOCUMENTATION: `Avancé : Ce bloc peut contenir différents types de blocs et leur appliquer des propriétés spécifiques au format JSON.
    
  Ce bloc peut contenir les blocs suivants et y appliquer les paramètres suivants :
  - Blocs mathématiques (expression algébriques ...):
  • 'smartDisplay' : "true" par défaut. Essaye de simplifier et transformer une expression mathématique le mieux possible.
  - Blocs géométriques (polygones, cercles...) : 
    • 'fillColor' pour remplir une figure avec une couleur déterminée par son code hexadécimal (par exemple '#ff0000') ou par 'random'.
    • 'dash' pour définir un motif en pointillés. La valeur doit être comprise entre 0 et 6 (0 : ligne pleine, 1 : ligne pointillée, 3 : ligne avec des tirets normaux...). 
    • 'group' pour grouper les points d'un polygone permettant une translation complète du polygone en déplacant n'importe lequel de ses sommets.
    - Bloc Tableau de données : isBordered (true par défaut) permet d'afficher ou non le bord des cases, isStriped (true par défaut) permet de griser une ligne sur deux, 'isHoverable' (false par défaut) permet d'éclairer les lignes lors du passage de la souris`,

  //BLOCK MARKDOWN
  MARKDOWN_TITLE: "markdown",
  MARKDOWN_MESSAGE: "markdown %1",
  MARKDOWN_TOOLTIP: `Permet d'utiliser la notation Markdown.
    Renvoie un objet HTML à afficher  
    Inclus le plus souvent dans un bloc "Affiche".
    Contient uniquement des blocs de type "Texte" et interprète les caractères markdown.

    - Exemples : commencer une ligne par # pour afficher un titre de niveau 1, par ## pour un titre de niveau 2, entourer un mot par deux ** pour le mettre en gras ...`,
  //BLOCK LATEX
  LATEX_TITLE: "LaTeX",
  LATEX_MESSAGE: "LaTeX %1",
  LATEX_TOOLTIP: `Permet d'utiliser la notation LaTeX.
    Renvoie un objet HTML à afficher    
    Inclus le plus souvent dans un bloc "Affiche".
    Contient uniquement des blocs de type "Texte" et interprète la notation LaTeX.  Le LaTeX est un langage très puissant permettant d'afficher des textes et formules scientifiques de manière élégante. Il faut préfixer les expressions par "\\".
    Pour en savoir plus : consultez la documentation`,

  LATEX_DOCUMENTATION: `Permet d'utiliser la notation LaTeX.
    Renvoie un objet HTML à afficher    
    Inclus le plus souvent dans un bloc "Affiche".
    Contient uniquement des blocs de type "Texte" et interprète la notation LaTeX.  Le LaTeX est un langage très puissant permettant d'afficher des textes et formules scientifiques de manière élégante. Il faut préfixer les expressions par "\\".
    
    - Exemple 1 : \\dfrac{ax+b}{b} dans un bloc "LaTeX" contenu dans un bloc "Affiche" affiche une fraction.
    - Exemple 2 : \\textrm{L'élément } u_2 \\textrm{ est le second élément de la suite } u_n pour mixer texte en latin et mathématiques
    - Exemple 3 : f(n)=\\begin{cases} n/2, & \\mbox{si }n\\mbox{ est pair} \\\\ 3n+1, & \\mbox{si }n\\mbox{ est impair} \\end{cases}
`,
  //BLOCK SPECIAL_CHARACTER
  SPECIAL_CHARACTER_TOOLTIP:
    "Effectue un retour à la ligne ou ajoute un séparateur ligne horizontale",

  //BLOCK VERSION
  VERSION_MESSAGE: "Créer les versions de l'activité avec",
  VERSION_DEFAULTVERSION: "version par défaut",
  VERSION_VERSIONN: "version n°",
  VERSION_LABEL: " ayant pour label",
  VERSION_TOOLTIP: "Permet de créer une activité multi-version.",

  CLEAN_ACTIVITY_MESSAGE: "Effacer tout le contenu de l'activité (beta)",
  CLEAN_ACTIVITY_TOOLTIP:
    "Efface tout le contenu d'une activité. Souvent utilisé dans un feedback pour permettre d'effacer l'historique des précédents énoncé, questions et feedback et afficher de nouvelles informations.",

  //BLOCK QUESTIONS
  //COMMON STRINGS CONTAINED IN QUESTION BLOCKS
  QUESTION_WARNING_NESTED_QUESTIONS:
    "Attention : pour imbriquer des questions, il faut obligatoirement, dans le bloc d'entête, fixer la valeur 'tentatives max' à 1.",
  QUESTION_GENERAL_MORE_OPTIONS_NB_PROPOSALS:
    "nombre de propositions à afficher",
  QUESTION_GENERAL_MORE_OPTIONS_DEFAULT_FEEDBACKS: "rétroaction par défaut",
  QUESTION_GENERAL_MORE_OPTIONS_DISPLAY: "affichage",
  QUESTION_GENERAL_MORE_OPTIONS_DISPLAY_EXTERNAL: "externe",
  QUESTION_GENERAL_MORE_OPTIONS_DISPLAY_INLINE: "imbriqué",
  QUESTION_GENERAL_MORE_OPTIONS_LEARNERANSWER_SAVEIN:
    "réponse apprenant stockée dans",
  QUESTION_GENERAL_MORE_OPTIONS_LEARNERANSWER_SAVEIN_NAMEVAR: "reponse",
  QUESTION_GENERAL_MORE_OPTIONS_QUESTION_SAVEIN: "question stockée dans",
  QUESTION_GENERAL_MORE_OPTIONS_QUESTION_SAVEIN_NAMEVAR: "question",
  QUESTION_GENERAL_MORE_OPTIONS_FEEDBACKS: "⏎ rétroactions",
  //BLOCK QUESTION_TRUE_FALSE
  QUESTION_TRUE_FALSE_TRUE: "vrai",
  QUESTION_TRUE_FALSE_FALSE: "faux",
  QUESTION_TRUE_FALSE_TITLE: "Question : répondre par vrai ou faux",

  QUESTION_TRUE_FALSE_MESSAGE:
    "❓ Question Vrai/Faux %1 texte %2 ✅ bonne réponse %3 %4 options avancées",
  QUESTION_TRUE_FALSE_TOOLTIP: `Demande de confirmer ou d'infirmer une proposition.
    - Texte : il contient le texte de la proposition ou une consigne.
    - Bonne réponse : Vrai ou faux. Elle peut être directement l'élément logique vrai ou faux, ou contenir le résultat d'un test logique plus complexe.
    Pour en savoir plus : consultez la documentation.`,

  QUESTION_TRUE_FALSE_DOCUMENTATION: `Demande de confirmer ou d'infirmer une proposition.
   - Texte : il contient le texte de la proposition ou une consigne.
   - Bonne réponse : Vrai ou faux. Elle peut être directement l'élément logique vrai ou faux, ou contenir le résultat d'un test logique plus complexe.
  
    Options avancées :
    - Affichage : l'option "externe" permet d'afficher la question après l'énoncé; l'option "imbriqué" permet d'afficher la question au sein de l'énoncé.
    - Réponse stockée dans : permet de choisir la variable qui enregistrera la réponse de l'apprenant correspondant à un boolean (vrai ou faux).
    - Rétroaction par défaut : permet d'activer ou pas l'affichage du message standard de réussite ou d'échec à la question.
    - Rétroactions : contient des blocs "Rétroaction (feedback)" qui permettent de déclencher des rétroactions relatives à cette question et selon la réponse de l'apprenant.
    
    Options Brutes (JSON) contient des paramètres spécifiques à fournir au format JSON : 
    - feedbackcolor (boolean) : "true" par défaut. Si "false", la zone de réponse de l'apprenant ne se colorise en fonction de sa réponse.
    - grade (boolean) : "true" par défaut. Si "false", c'est le bloc "Définir manuellement la note" qui fixera l'apprenant lors de la réalisation d'une séquence.
    `,

  //BLOCK MULTIPLE_CHOICES_QUESTION
  QUESTION_MULTIPLE_CHOICES_TITLE: "Question à choix multiples",

  QUESTION_MULTIPLE_CHOICES_MESSAGE:
    "❓ Question Choix Multiple %1 type %2 %3 texte %4 ✅ bonne(s) réponse(s) %5 ❌ mauvaises réponses %6 %7 options avancées",

  QUESTION_MULTIPLE_CHOICES_MULTIPLE: "plusieurs bonnes réponses",
  QUESTION_MULTIPLE_CHOICES_UNIQUE: "une seule bonne réponse",

  QUESTION_MULTIPLE_CHOICES_TOOLTIP: `Demande de choisir une ou plusieurs réponses parmi un ensemble de propositions.
    - Type : permet de définir un QCM à choix unique ou un QCM à choix multiple.
    - Texte : il contient le texte de la proposition ou une consigne.
    - Bonnes réponses : Liste des réponses considérées comme exactes.
    - Mauvaises réponses : Liste des réponses considérées comme mauvaises.
    Pour en savoir plus : consultez la documentation.`,

  QUESTION_MULTIPLE_CHOICES_DOCUMENTATION: `Demande de choisir une ou plusieurs réponses parmi un ensemble de propositions.
    - Type : permet de définir un QCM à choix unique (une seule réponse possible parmi un ensemble de propositions) ou un QCM à choix multiple (plusieurs réponses possibles parmi un ensemble de propositions).
    - Texte : il contient le texte de la proposition ou une consigne.
    - Bonnes réponses : Liste des réponses considérées comme exactes (dans le cas d'un QCM de type choix unique la liste est soit une liste contenant seul élément ou simplement un élément).
    - Mauvaises réponses : Liste des réponses considérées comme mauvaises.

    Options avancées :
    - Nombre de propositions à afficher : Laisser vide pour afficher l'ensemble des possibilités (bonnes et mauvaises). Si précisé, permet de choisir aléatoirement un nombre limité de propositions à présenter à l'apprenant parmi l'ensemble des bonnes et mauvaises réponses. Dans un QCM 'choix unique', la bonne réponse sera toujours proposée. Dans un QCM 'choix multiples', il est possible que seules des propositions incorrectes soient proposées; dans ce cas l'apprenant ne devra rien cocher pour avoir juste.
    - Affichage : l'option "externe" permet d'afficher la question après l'énoncé; l'option "imbriqué" permet d'afficher la question au sein d'un énoncé.
    - Réponse stockée dans : permet de choisir la variable qui enregistrera la réponse de l'apprenant. La variable contiendra la liste des éléments cochés par l'apprenant.
    - Rétroaction par défaut : permet d'activer ou pas l'affichage du message standard de réussite ou d'échec à la question.
    - Rétroactions : contient des blocs "Rétroaction (feedback)" qui permettent de déclencher des rétroactions relatives à cette question et selon la réponse de l'apprenant.
    
    Options Brutes (JSON) contient des paramètres spécifiques à fournir au format JSON : 
    - feedbackcolor (boolean) : "true" par défaut. Si "false", la zone de réponse de l'apprenant ne se colorise en fonction de sa réponse.
    - grade (boolean) : "true" par défaut. Si "false", c'est le bloc "Définir manuellement la note" qui fixera l'apprenant lors de la réalisation d'une séquence.
 `,

  //BLOCK QUESTION_OPEN
  //=> ajouter var glob pour les inputs
  QUESTION_OPEN_TYPE_INTEGER_POSITIVE: "entier positif",
  QUESTION_OPEN_TYPE_INTEGER: "entier",
  QUESTION_OPEN_TYPE_DECIMAL: "décimal",
  QUESTION_OPEN_TYPE_FRACTION: "fraction",
  QUESTION_OPEN_TYPE_TEXT: "texte",
  QUESTION_OPEN_TYPE_EXPRESSION: "expression mathématique",
  QUESTION_OPEN_TYPE_LIST: "liste ou matrice (disponible bientôt)",
  QUESTION_OPEN_OPTION_CASE_SENSITIVE: "Respect de la casse",
  QUESTION_OPEN_OPTION_TITLE: "options brutes (JSON)",

  QUESTION_OPEN_TITLE: "Question ouverte",

  QUESTION_OPEN_MESSAGE:
    "❓ Question Ouverte %1 texte %2 type de réponse attendue %3 %4 ✅ bonne réponse %5 %6 options avancées",
  QUESTION_OPEN_TOOLTIP: `Demande de donner une valeur d'un certain type.
    - Texte : il contient le texte de la proposition ou une consigne.  
    - Type de réponse attendue : correspond au type de valeur attendue.
    - Bonne réponse : La valeur correspondant à la bonne réponse. Elle peut être directement la valeur, une variable ou contenir le résultat d'un calcul plus complexe.
    Pour en savoir plus : consultez la documentation.`,

  QUESTION_OPEN_DOCUMENTATION: `Demande de donner une valeur d'un certain type.
    - Texte : il contient le texte de la proposition ou une consigne.
    - Type de réponse attendue : correspond au type de valeur attendue.
    • Texte : la réponse attendue est un texte. Pour être considérée comme juste, la réponse donnée devra être saisie exactement comme la bonne réponse (en respectant majuscules, minuscules, accents...). Des réglages plus fins seront implémentés prochainement pour tenir compte ou non de la casse, d'accents, d'espaces superflus, de fautes d'orthographe...
    • Entier ou entier positif : la réponse attendue est un nombre entier. La valeur numérique (Entier) correspondant à la bonne réponse. Elle peut être directement la valeur, une variable ou contenir le résultat d'un calcul plus complexe.
    • Décimal : la réponse attendue est un nombre décimal. Pour être considérée comme juste, la réponse devra ne pas être arrondie. Des réglages plus fins seront implémentés prochainement pour tenir de la précision (nombre de chiffres significatifs)...
    • Fraction : la réponse attendue est une fraction. Pour être considéré comme juste, la réponse devra être saisie comme fraction irréductible.
    • Expression : la réponse attendue est une expression symbolique (ex. : 3x+2). Pour être considéré comme juste la réponse donnée devra être équivalente (ex : 2+3*x)
    • Liste ou Matrice : la réponse attendue est une liste ou une matrice saisie sous la forme [[1,2],[3,4]].
    - Bonne réponse : La valeur correspondant à la bonne réponse. Elle peut être directement la valeur, une variable ou contenir le résultat d'un calcul plus complexe.

    Options avancées :
    - Affichage : l'option "externe" permet d'afficher la question après l'énoncé; l'option "imbriqué" permet d'afficher la question au sein de l'énoncé.
    - Réponse stockée dans : permet de choisir la variable qui enregistrera la réponse saisie par l'apprenant.
    - Rétroaction par défaut : permet d'activer ou pas l'affichage du message standard de réussite ou d'échec à la question.
    - Rétroactions : contient des blocs "Rétroaction (feedback)" qui permettent de déclencher des rétroactions relatives à cette question et selon la réponse de l'apprenant.
    
    Options Brutes (JSON) contient des paramètres spécifiques à fournir au format JSON :
    
    - Pour tous les types de réponses attendues : 
    • feedbackcolor (boolean) : "true" par défaut. Si "false", la zone de réponse de l'apprenant ne se colorise en fonction de sa réponse.
    • grade (boolean) : "true" par défaut. Si "false", c'est le bloc "Définir manuellement la note" qui fixera l'apprenant lors de la réalisation d'une séquence.

    • emptyMeansZero (boolean) : "false" par défaut. Si "true", une réponse laissée vide est considérée comme la valeur 0.
    • callbackSolution (boolean) : "false" par défaut. Si "true", la réponse correcte est une procedure retournant un boolean au lieu d'une valeur. Cette procédure retourne vrai ou faux selon votre analyse de la réponse de l'apprenant.
    • length (nombre) : Options uniquement éffective pour les questions ouvertes imbriquées. 10 par défaut, elle correspond approximativement au nombre de caractères pouvant être affichés dans le champ de saisie.

    - Pour tous les types Texte Entier et Décimal : 
    • maxLength (nombre) : Options uniquement éffective pour les questions ouvertes imbriquées. Elle limite le nombre de caractères que l'apprenant peut saisir dans le champ de saisie.

    - Pour le type Texte : 
    • caseSensitive (boolean) : "false" par défaut. Si "true", la réponse doit respecter les Majuscules/Minuscules pour être considérée comme juste.
    • spaceSensitive (boolean) :  "false" par défaut. Si "true", la réponse ne doit pas contenir d'espaces superflus pour être considérée comme juste
    
    - Pour le type Décimal : 
    • precision (integer) : définit à combien de chiffres significatifs doit être arrondi la réponse pour être considérée comme juste.

    - Pour le type Fraction : 
    • irreducibleFraction (boolean) : "false" par défaut. Si "true", la réponse doit être irréductible pour être considérée comme juste.
 
    
    Exemple si le type Texte a été choisi :
    { "caseSensitive" : true, "spaceSensitive" : true}
    permet d'indiquer que la réponse est considérée comme juste si elle respecte les majuscules et minuscules et qu'elle ne contient aucun espace superflu.
    `,

  //BLOCK QUESTION_REORDER
  QUESTION_REORDER_TITLE: "Question : ordonner des éléments",
  QUESTION_REORDER_TEXT: "Ordonne les éléments",
  QUESTION_REORDER_MESSAGE:
    "❓ Question Ordonner %1 texte %2 ✅ Liste à ordonner %3 %4 options avancées",
  QUESTION_REORDER_TOOLTIP: `Demande d'ordonner des éléments entre eux.
    - Liste à ordonner : La liste des éléments correctement ordonnés.
    Pour en savoir plus : consultez la documentation.`,

  QUESTION_REORDER_DOCUMENTATION: `Demande d'ordonner des éléments entre eux.
    - Liste à ordonner : La liste des éléments correctement ordonnés.
  
    Options avancées :
    - Nombre de propositions à afficher : Laisser vide pour afficher l'ensemble des éléments de la liste à ordonner. Si précisé, permet de choisir aléatoirement un nombre limité de propositions à présenter à l'apprenant.
    - Réponse stockée dans : permet de choisir la variable qui enregistrera la réponse de l'apprenant. La variable contiendra la liste des éléments dont les positions sont correctes. Par déduction on trouvera les éléments mal positionnés.
    - Rétroaction par défaut : permet d'activer ou pas l'affichage du message standard de réussite ou d'échec à la question.
    - Rétroactions : contient des blocs "Rétroaction (feedback)" qui permettent de déclencher des rétroactions relatives à cette question et selon la réponse de l'apprenant.
  
    Options Brutes (JSON) contient des paramètres spécifiques à fournir au format JSON : 
    - grade (boolean) : "true" par défaut. Si "false", c'est le bloc "Définir manuellement la note" qui fixera l'apprenant lors de la réalisation d'une séquence.
    `,

  //BLOCK QUESTION_ASSOCIATE
  QUESTION_ASSOCIATE_TITLE: "Question : associer des éléments",
  QUESTION_ASSOCIATE_MESSAGE:
    "❓ Question Associer %1 texte %2 ✅ Liste d'éléments %3 ✅ Liste de caractéristiques %4 %5 options avancées",
  QUESTION_ASSOCIATE_TEXT: "Associe les éléments",
  QUESTION_ASSOCIATE_TOOLTIP: `Demande d'associer des éléments à leur caractéristique. Chaque élément doit avoir une caractéristique unique.
    - Éléments : La liste des éléments.
    - Caractéristiques : La liste des caractéristiques des éléments correspondants.
    L'élément en indice 'i' de la liste des éléments a la caractéristique en indice 'i' de la liste des caractéristiques.
    Pour en savoir plus : consultez la documentation.
    `,

  QUESTION_ASSOCIATE_DOCUMENTATION: `Demande d'associer des éléments à leur caractéristique. Chaque élément doit avoir une caractéristique unique.
    - Éléments : La liste des éléments.
    - Caractéristiques : La liste des caractéristiques des éléments correspondants.
    L'élément en indice 'i' de la liste des éléments a la caractéristique en indice 'i' de la liste des caractéristiques.
  
    Options avancées :
    - Enregistre la reponse de l'apprenant dans : permet de choisir la variable qui enregistrera la réponse de l'apprenant. La variable contiendra la liste des éléments correctement associés à leur caractéristique,
    - Nombre de propositions à afficher : Laisser vide pour afficher l'ensemble des éléments et leurs caractéristiques. Si précisé, permet de choisir aléatoirement un nombre limité d'éléments avec leur caractéristique.
    - Rétroaction par défaut : permet d'activer ou pas l'affichage du message standard de réussite ou d'échec à la question.
    - Rétroactions : contient des blocs "Rétroaction (feedback)" qui permettent de déclencher des rétroactions relatives à cette question et selon la réponse de l'apprenant.
    
    Options Brutes (JSON) contient des paramètres spécifiques à fournir au format JSON : 
    - grade (boolean) : "true" par défaut. Si "false", c'est le bloc "Définir manuellement la note" qui fixera l'apprenant lors de la réalisation d'une séquence.
    `,

  //BLOC QUESTION_FIGURE
  QUESTION_FIGURE_TITLE: "Question sur un graphique",
  QUESTION_FIGURE_MESSAGE:
    "❓ Question sur un graphique %1 graphique concerné %2 %3 ✅ condition bonne réponse %4 %5 options avancées",
  QUESTION_FIGURE_TOOLTIP: `Demande d'interagir sur un graphique (déplacer des points, construire une figure...).
    - Graphique concerné : variable dans lequel est enregistré le graphique.
    - Condition bonne réponse : boolean résultat d'un test (par exemple tester les coordonnées d'un point).
    `,

  QUESTION_FIGURE_DOCUMENTATION: `Demande d'interagir sur un graphique (déplacer des points, construire une figure...).
    - Graphique concerné : variable dans lequel est enregistré le graphique.
    - Condition bonne réponse : boolean résultat d'un test (par exemple tester les coordonnées d'un point).
   
    Options Brutes (JSON) contient des paramètres spécifiques à fournir au format JSON : 
    - grade (boolean) : "true" par défaut. Si "false", c'est le bloc "Définir manuellement la note" qui fixera l'apprenant lors de la réalisation d'une séquence.
   
    `,

  //CATEGORY FEEDBACK

  //BLOCK FEEDBACK_MESSAGE_TYPE
  FEEDBACK_MESSAGE_TYPE_MESSAGE:
    "Régler le ton des messages des rétroactions sur %1",
  FEEDBACK_MESSAGE_TYPE_KIDS: "Enfants/Adolescents",
  FEEDBACK_MESSAGE_TYPE_NEUTRAL: "Neutre",
  FEEDBACK_MESSAGE_TYPE_FORMAL: "Formel",
  FEEDBACK_MESSAGE_TYPE_TOOLTIP: `Choisissez le ton utilisé pour les messages de feedback à afficher. 
  Le ton des messages des rétroactions peut être neutre, orienté pour les enfants/adolescents ou les adultes (formel). 
  Par défaut, le ton des messages des rétroactions est neutre.`,

  FEEDBACK_TITLE: "rétroaction",
  FEEDBACK_MESSAGE: "⏎ Rétroaction (deprecated) %1 si %2 affiche %3",
  FEEDBACK_TOOLTIP: `Permet d'afficher des messages en fonction de tests logiques.
    - si : correspond au test logique qui déclenche l'affichage du texte. Le plus souvent le test logique est réalisé sur la variable qui enregistre la réponse de l'apprenant.
    - affiche : Le texte à afficher si le test est vrai. Tout élément affichable peut être choisi (textes, graphiques ...).`,

  //PSEUDO FEEDBACK BLOCKS
  FEEDBACK_LOCAL_TITLE: "Exemple",
  FEEDBACK_GLOBAL_EXAMPLE_DOCUMENTATION: `Cet ensemble est un exemple préconstruit à intéger à la fin d’une activité.
En fonction des réponses de l'apprenant aux questions, on affiche un message personnalisé.`,
  FEEDBACK_TEST_ATTEMPTS_DOCUMENTATION: `Cet ensemble est un exemple préconstruit à intéger dans les options avancées d'un bloc question ou du bloc feedback global.
    Il fournit un moyen simple de tester la tentative actuelle de l'apprenant ou les tentatives restantes de l'apprenant. Ainsi, vous pouvez concevoir un feedback progressif qui prennent en compte le nombre de tentatives consommées.`,

  //CATEGORY FEEDBACK
  //BLOCK FEEDBACK GLOBAL
  FEEDBACK_GLOBAL_TITLE: "rétroactions globales",
  FEEDBACK_GLOBAL_MESSAGE: "rétroactions globales %1",
  FEEDBACK_GLOBAL_TOOLTIP:
    "Contient des blocs qui permettent de déclencher des rétroactions relatives à cette activité et toutes ces questions. Le plus souvent les rétroactions globales sont fonction des réponses des apprenants.",

  //BLOCK ISSOLUTIONFOUND
  FEEDBACK_IS_SOLUTION_FOUND: "solution à cette question est trouvée",
  FEEDBACK_ARE_ALL_SOLUTIONS_FOUND:
    "Toutes les solutions aux questions sont trouvées",
  FEEDBACK_IS_SOLUTION_FOUND_TOOLTIP: `doit être utilisé au sein des rétroactions d'une question ou du bloc rétroactions globales.
  - solution à cette question trouvée : Renvoie vrai si la solution de la question a été trouvée.
  - toutes les solutions des questions de l'activité trouvées : Renvoie vrai toutes les solutions des questions de l'activité ont été trouvées.
     `,

  //BLOCK CURRENT_ATTEMPT
  FEEDBACK_CURRENT_ATTEMPT_MESSAGE: "tentative de l'apprenant en cours",
  FEEDBACK_CURRENT_ATTEMPT_TOOLTIP: `doit être utilsé au sein des rétroactions d'une question ou du bloc rétroactions globales.
  - Renvoie un entier correspondant au numéro de la tentative en cours de l'apprenant.`,

  //BLOCK MAX_ATTEMPTS
  FEEDBACK_MAX_ATTEMPTS_MESSAGE: "tentatives maximum de l'activité",
  FEEDBACK_MAX_ATTEMPTS_TOOLTIP: `doit être utilsé au sein des rétroactions d'une question ou du bloc rétroactions globales.
  - Renvoie un entier correspondant au nombre de tentatives maximum défini dans l'activité.`,

  //BLOCK MESSAGE
  FEEDBACK_MESSAGE_TOOLTIP: "Renvoie un message prédéfini de rétroaction.",
  FEEDBACK_MESSAGE_MESSAGE: "message",
  FEEDBACK_MESSAGE_SOLUTION_FOUND_ATFIRSTATTEMPT:
    "Solution trouvée à la première tentative",
  FEEDBACK_MESSAGE_SOLUTION_FOUND: "Solution trouvée",
  FEEDBACK_MESSAGE_SOLUTION_NOTFOUND_BUTREMAININGATTEMPTS:
    "Solution non trouvée mais tentatives restantes",
  FEEDBACK_MESSAGE_SOLUTION_NOTFOUND: "Solution non trouvée",

  CONTEXT_QUESTION_MESSAGE: "Dans le contexte de la question %1 %2 %3",
  CONTEXT_QUESTION_TOOLTIP:
    "Permet de travailler dans le contexte d'une question. Utile pour externaliser dans une procédure les rétroactions d'une question.",

  SET_GRADE_MESSAGE: "Terminer l'activité et définir la note à %1%",
  SET_GRADE_TOOLTIP:
    "Ce bloc définit manuellement une note pour l'activité et met fin à l'activité. Cette note sera enregistrée dans les statistiques d'une séquence et remplacera celle par défaut.",

  SET_ANALYTIC_MESSAGE:
    "Enregistrer un learning analytic ayant pour clé %1 et pour valeur %2",
  SET_ANALYTIC_TOOLTIP:
    "Ce bloc enregistre un indicateur de suivi (learning analytic) défini par une clé et une valeur. Cet analytic permet d'enregistrer des valeurs durant l'exécution de l'activité par un apprenant. La valeur de l'analytic sera ensuite consultable depuis les statistiques d'une séquence.",

  //BLOCK IA
  IA_TITLE: "IA",
  IA_MESSAGE: "IA (à venir...) %1",
  IA_TOOLTIP:
    "Les fonctions d'Intelligence Artificielle seront prochainement implémentées.",

  //MATH ARITHMETIC
  //RANDOM_NUMBER
  RANDOM_NUMBER_MESSAGE: "🎲 %1 aléatoire entre%2 et%3",
  RANDOM_NUMBER_INTEGER: "entier",
  RANDOM_NUMBER_DECIMAL: "décimal",
  RANDOM_NUMBER_TOOLTIP:
    "Renvoie un nombre aléatoire (entier ou décimal) plus grand ou égal que le minimum et strictement plus petit que le maximum selon un distribution uniforme",
  //BLOCK ROUND_DECIMAL
  ROUND_DECIMAL_MESSAGE: "arrondi de %1 à %2 décimales",
  ROUND_DECIMAL_TOOLTIP: "Renvoie l'arrondi d'un nombre à n décimales.",

  //BLOCK INTEGER_DECIMAL_PART
  INTEGER_DECIMAL_PART_MESSAGE: "%1 %2",
  INTEGER_DECIMAL_PART_INTEGER: "partie entière",
  INTEGER_DECIMAL_PART_DECIMAL: "partie décimale",
  INTEGER_DECIMAL_PART_TOOLTIP:
    "Renvoie la partie entière ou décimale d'un nombre.",

  //BLOCK SPLIT_NUMBER
  SPLIT_NUMBER_MESSAGE: "décompose le nombre %1 en chiffres",
  SPLIT_NUMBER_TOOLTIP: "Renvoie la liste des chiffres composant un nombre",

  //BLOCK INTEGER_PART
  INTEGER_PART_MESSAGE: "partie entière de %1",
  INTEGER_PART_TOOLTIP: "Renvoie la partie entière d'un nombre.",

  //BLOCK DECIMAL_PART
  DECIMAL_PART_MESSAGE: "partie décimale de %1",
  DECIMAL_PART_TOOLTIP: "Renvoie la partie décimale d'un nombre.",

  //BLOCK GCD_LCM
  GCD_LCM_OPERATOR_GCD: "PGCD",
  GCD_LCM_OPERATOR_LCM: "PCCM",
  GCD_LCM_MESSAGE: "%1 de la liste  %2",
  GCD_LCM_TOOLTIP: "Renvoie le PGCD or PPCM de tous les nombres dans la liste.",

  /////////////////////
  //MATH GEOMETRY
  BOARD_TITLE: "graphique",
  BOARD_GEOMETRIC_MESSAGE:
    "📈 Graphique Xmin%1 Xmax%2 Ymin%3 Ymax%4 ⊞%5 %6 %7▦ %8 %9🕹",
  BOARD_SIZE_SMALL: "petite",
  BOARD_SIZE_MEDIUM: "moyenne",
  BOARD_SIZE_BIG: "grande",

  BOARD_AXES_XY: "X & Y",
  BOARD_AXES_X: "X seulement",
  BOARD_AXES_Y: "Y seulement",
  BOARD_AXES_NONE: "Aucun",

  BOARD_TOOLTIP: `
  Crée un graphique selon les bornes infèrieurs et supèrieurs choisies avec ou sans l'affichage des axes et avec ou sans grille.
  Est suivi le plus souvent de blocs Dessiner qui dessineront dans le graphique différents éléments géométriques.
  Peut être inclus dans un bloc Taille (XL-S) pour changer la taille d'affichage du graphique.
  `,
  //DRAW
  DRAW_MESSAGE: "Dessiner %1", //Obsolete
  DRAW_IN_BOARD_MESSAGE: "dessiner %1 dans le graphique%2",
  DRAW_TOOLTIP: `Dessine un élément géométrique.
  Contient un element géométrique à dessiner dans le graphique sélectionné.
  Préalablement, une variable graphique doit être définie.`,

  //ERASE IN BOARD
  ERASE_IN_BOARD_MESSAGE: "effacer %1 dans le graphique%2",
  ERASE_IN_BOARD_TOOLTIP: `Efface un élément géométrique.
  Contient la variable de l'élement géométrique à effacer dans le graphique sélectionné.
  Préalablement, la variable de l'élément graphique et le graphique doivent être définies.`,

  //ERASE IN BOARD
  ERASE_ALL_BOARD_MESSAGE: "effacer tous les éléments dans le graphique %1",
  ERASE_ALL_BOARD_TOOLTIP: `Efface la totalité des éléments géométriques d'un graphique.
  Contient la variable du graphique à effacer.
  Préalablement, la variable du graphique doit être définie.`,

  //BLOCK POLYGON
  POLYGON_MESSAGE: "polygone ayant pour sommets %1",
  POLYGON_TOOLTIP: `Renvoie un polygone de n sommets.
    Contient une liste de sommets. Pour définir une couleur, l'inclure dans un bloc couleur.
    Inclus le plus souvent dans un bloc "Dessiner".`,

  //POINT
  POINT_MESSAGE: "point %1 x%2 y%3 %4 %5 options ",
  POINT_TOOLTIP_WITHLABEL: "dessiner le point",
  POINT_TOOLTIP_SHOWINFOBOX: "afficher les coordonnées",
  POINT_TOOLTIP_FIXED: "fixé ou déplacable",
  POINT_TOOLTIP:
    "Renvoie un point de coordonnées x et y. Options : voir documentation",
  POINT_DOCUMENTATION: `Renvoie un point de coordonnées x et y.
  Options :
  - 🔵 : dessine le point.
  - 💬 : affiche les coordonées du point lors du survol.
  - 🔒 : définit si le point est fixe ou peut être déplacé.
  - 🧲 : définit les attracteurs =>
  - Un attracteur peut être un nombre entier : Le point ne peut être positionné que sur les abscisses et ordonnés multiples de cet nombre.
  - Un attracteur peut être une liste [a,b] : Le point ne peut être positionné que sur les abscisses multiples de a et les ordonnés multiples b.
  - Un attracteur peut être une autre figure : Le point ne peut être positionné que sur le contour de cette figure.`,

  //POINT COORDINATE
  FIGURE_COORDINATE_MESSAGE: "coordonnée %1 du point enregistré dans %2",
  FIGURE_COORDINATE_TOOLTIP: `Renvoie la coordonnée x or y du point enregistré dans une variable.
  Préalablement le point doit être enregistré dans une variable.`,

  //LINE
  LINE_LINE: "droite",
  LINE_SEGMENT: "segment",
  LINE_ARROW: "flèche",
  LINE_DOTTED: "pointillé",
  LINE_MESSAGE: "%1 passant par%2 et%3",
  LINE_TOOLTIP: `Renvoie une droite, un segment ou une flèche passant par deux points.`,
  //TANGENT
  TANGENT_MESSAGE: "tangente passant par %1",
  TANGENT_TOOLTIP: `Renvoie une tangente définie par un point ayant un ou des attracteurs`,
  //CIRCLE
  CIRCLE_MESSAGE: "cercle de centre%1 et de rayon%2",
  CIRCLE_TOOLTIP: `Renvoie un cercle défini par un point représentant son centre et son rayon.`,
  //DISK - SECTOR - CIRCLE PORTION
  SECTOR_MESSAGE:
    "secteur circulaire ayant pour centre%1 et défini par le point%2 et le point%3",
  SECTOR_TOOLTIP:
    "Renvoie un secteur est défini par trois points : Le centre p1 du secteur, un deuxième point p2 définissant le rayon et un troisième point p3 définissant l'angle du secteur. Le secteur est toujours dessiné dans le sens inverse des aiguilles d'une montre de p2 à p3.",

  SECTOR_DOCUMENTATION: `Renvoie un secteur circulaire ayant pour centre%1 et défini par le point%2 et le point%3
  Paramètres avancées (appliquer le bloc Paramétrer ... avec ...) :
      • "arcOnly": true / false
      • "hasFirstArrow": true / false
      • "hasLastArrow":true/false
  `,
  //BOARD_TEXT
  BOARD_TEXT_MESSAGE: "texte %1 positionné à %2",
  BOARD_TEXT_TOOLTIP:
    "Renvoie un texte défini par un texte et sa position grâce à un point.",
  //BLOCK RANDOMPOLYGON
  RANDOMPOLYGON_MESSAGE: "🎲 polygone aléatoire à %1 cotés",
  RANDOMPOLYGON_TOOLTIP: `Renvoie un polygone à n sommets choisis aléatoirement. Les coordonnées des sommets sont choisies dans un graphique par défaut.`,
  //BLOCK REGULARPOLYGON
  REGULARPOLYGON_MESSAGE:
    "polygone régulier de centre%1 de %2cotés et de rayon%3",
  REGULARPOLYGON_TOOLTIP: `Renvoie un polygone régulier définit par son centre son nombre de côtés et son rayon.`,

  //BLOCK RECTANGLE
  RECTANGLE_MESSAGE: "rectangle de longueur %1 %2 de largeur %3 %4",
  RECTANGLE_TOOLTIP:
    "Renvoie un rectangle défini par sa longueur, largeur et positionné aléatoirement dans un graphique. Les coordonnées des sommets sont choisies dans un graphique par défaut.",
  //BLOCK FIGURE_PERIMETER
  FIGURE_PERIMETER_MESSAGE: "périmètre de la figure %1",
  FIGURE_PERIMETER_TOOLTIP: `Renvoie le périmètre de la Figure géométrique
  Contient une figure géométrique (rectangle, polygone...).`,
  //BLOCK FIGURE_AREA
  FIGURE_AREA_MESSAGE: "aire de la figure %1",
  FIGURE_AREA_TOOLTIP: `Renvoie l'aire de la Figure géométrique
  Contient une figure géométrique (rectangle, polygone, cercle,...).`,

  //BLOCK FIGURE_TRANSFORMS
  FIGURE_ROTATE_MESSAGE: "faire tourner %1 de %2°",
  FIGURE_ROTATE_TOOLTIP: `Faire tourner la figure de x degrés.`,
  FIGURE_TRANSLATE_MESSAGE: "translater %1 de [%2,%3]",
  FIGURE_TRANSLATE_TOOLTIP: `Translate la figure selon le vecteur [x,y].`,
  FIGURE_SCALE_MESSAGE: "mettre à l'échelle %1 par [%2,%3]",
  FIGURE_SCALE_TOOLTIP: `Mets à l'échelle la figure selon le vecteur [x,y].`,
  //BLOCK EUCLIDEAN_DISTANCE_TWOPOINTS
  EUCLIDEAN_DISTANCE_TWOPOINTS_MESSAGE: "distance entre %1 et %2",
  EUCLIDEAN_DISTANCE_TWOPOINTS_TOOLTIP: `Renvoie la distance entre deux points.
    Contient deux points.`,
  //BLOCK EUCLIDEAN_DISTANCE
  EUCLIDEAN_DISTANCE_MESSAGE: "distance entre x1%1 y1%2 et x2%3 y2%4",
  EUCLIDEAN_DISTANCE_TOOLTIP: `Renvoie la distance entre deux points.
  Contient deux points.`,
  //BLOCK FIGURE_CLONE
  FIGURE_CLONE_MESSAGE: "clone de %1",
  FIGURE_CLONE_TOOLTIP: `Renvoie un clone d'une figure géométrique
  Contient une figure géométrique (rectangle, polygone, cercle...).`,

  //MATH ALGEBRA
  //BLOCK RANDOMPOLYNOM
  RANDOMPOLYNOM_MESSAGE:
    "🎲 polynôme aléatoire de degré %1 ayant pour coefficients %2 ",
  RANDOMPOLYNOM_TOOLTIP: `Renvoie un polynôme aléatoire de type expression, exprimé avec la variable 'x'. Exemple : x^2+2x-1.`,

  //BLOCK RANDOMPOLYNOM
  POLYNOM_WITH_COEFFICIENTS_MESSAGE: "polynôme avec les coefficients %1",
  POLYNOM_WITH_COEFFICIENTS_TOOLTIP: `Renvoie un polynôme définie par une liste de coefficients.`,

  //BLOCK GRAPH_OF_FUNCTION
  GRAPH_OF_FUNCTION_MESSAGE: "graphique de f(x)= %1",
  GRAPH_OF_FUNCTION_TOOLTIP:
    "Renvoie la représentation graphique de la fonction définie par un texte ou une expression.",

  //BLOCK GRAPH_OF_FUNCTION_INTERVAL
  GRAPH_OF_FUNCTION_INTERVAL_MESSAGE: "graphique de f(x)= %1 sur [ %2 , %3 ]",
  GRAPH_OF_FUNCTION_INTERVAL_TOOLTIP:
    "Renvoie la représentation graphique de la fonction définie par un texte ou une expression dans un intervalle.",

  //BLOCK AREA_UNDER_FUNCTION_INTERVAL
  AREA_UNDER_FUNCTION_INTERVAL_MESSAGE: "aire sous f(x)= %1 sur [ %2 , %3 ]",
  AREA_UNDER_FUNCTION_INTERVAL_TOOLTIP:
    "Renvoie la représentation graphique de l'aire sous la fonction définie par un texte ou une expression dans un intervalle.",

  //BLOCK EXPRESSION
  EXPRESSION_MESSAGE: "expression %1",
  EXPRESSION_TOOLTIP:
    "Renvoie une expression définie par un texte (ex. : 2*x+3).",
  //BLOCK DEGREE
  DEGREE_MESSAGE: "degré du polynome %1 par rapport à %2",
  DEGREE_TOOLTIP:
    "Renvoie le degré d'un polynome par rapport à la variable définie.",
  //BLOCK COEFFICIENTS
  COEFFICIENTS_MESSAGE:
    "liste des coefficients du polynome %1 par rapport à %2",
  COEFFICIENTS_TOOLTIP:
    "Renvoie la liste des conefficients (du plus petit au plus grand degré) d'un polynome par rapport à la variable définie.",
  //PSEUDO BLOCK ADD POLYNOM
  COEFFICIENTS_OPERATOR_TOOLTIP:
    "Renvoie a nouveau polynome qui est l'addition de deux polynomes. Fonctionne aussi avec la soustraction.",
  //BLOCK DERIVATIVE
  DERIVATIVE_MESSAGE: "dérivée de %1 par rapport à %2",
  DERIVATIVE_TOOLTIP:
    "Renvoie la dérivée d'une expression par rapport à la variable définie.",
  //BLOCK PRIMITIVE
  PRIMITIVE_MESSAGE: "primitive de %1 par rapport à %2",
  PRIMITIVE_TOOLTIP:
    "Renvoie la primitive d'une expression par rapport à la variable définie.",
  //BLOCK INTEGRAL
  INTEGRAL_MESSAGE: "intégrale de %1 par rapport à %2 sur [ %3 , %4 ]",
  INTEGRAL_TOOLTIP:
    "Renvoie l'intégrale d'une expression par rapport à la variable définie sur un intervalle.",
  //BLOCK EVALUATE
  EVALUATE_MESSAGE: "valeur de %1 pour %2=%3",
  EVALUATE_TOOLTIP:
    "Renvoie l'évaluation de l'expression lorsque sa variable est égale à une valeur.",
  //BLOCK SIMPLIFY
  SIMPLIFY_MESSAGE: "simplification de %1",
  SIMPLIFY_TOOLTIP: "Renvoie la forme simplifiée d'une expression.",
  //BLOCK EXPAND
  EXPAND_MESSAGE: "développement de %1",
  EXPAND_TOOLTIP: "Renvoie la forme développée d'une expression.",
  //BLOCK UNIT
  UNIT_MESSAGE: "valeur numérique %1 unité %2",
  UNIT_TOOLTIP:
    "Renvoie un objet Unité pouvant être affiché ou converti dans une autre unité.",
  UNIT_DOCUMENTATION: `Renvoie un objet Unité pouvant être affiché ou converti dans une autre unité.
    Liste des unités acceptées : 
    - Length 	meter (m), inch (in), foot (ft), yard (yd), mile (mi), link (li), rod (rd), chain (ch), angstrom, mil
    - Surface area 	m2, sqin, sqft, sqyd, sqmi, sqrd, sqch, sqmil, acre, hectare
    - Volume 	m3, litre (l, L, lt, liter), cc, cuin, cuft, cuyd, teaspoon, tablespoon
    - Liquid volume 	minim, fluiddram (fldr), fluidounce (floz), gill (gi), cup (cp), pint (pt), quart (qt), gallon (gal), beerbarrel (bbl), oilbarrel (obl), hogshead, drop (gtt)
    - Angles 	rad (radian), deg (degree), grad (gradian), cycle, arcsec (arcsecond), arcmin (arcminute)
    - Time 	second (s, secs, seconds), minute (min, mins, minutes), hour (h, hr, hrs, hours), day (days), week (weeks), month (months), year (years), decade (decades), century (centuries), millennium (millennia)
    - Frequency 	hertz (Hz)
    - Mass 	gram(g), tonne, ton, grain (gr), dram (dr), ounce (oz), poundmass (lbm, lb, lbs), hundredweight (cwt), stick, stone
    - Electric current 	ampere (A)
    - Temperature 	kelvin (K), celsius (degC), fahrenheit (degF), rankine (degR)
    - Amount of substance 	mole (mol)
    - Luminous intensity 	candela (cd)
    - Force 	newton (N), dyne (dyn), poundforce (lbf), kip
    - Energy 	joule (J), erg, Wh, BTU, electronvolt (eV)
    - Power 	watt (W), hp
    - Pressure 	Pa, psi, atm, torr, bar, mmHg, mmH2O, cmH2O
    - Electricity and magnetism 	ampere (A), coulomb (C), watt (W), volt (V), ohm, farad (F), weber (Wb), tesla (T), henry (H), siemens (S), electronvolt (eV)
    - Binary 	bits (b), bytes (B)`,
  //BLOCK CONVERT_INTO_UNIT
  CONVERT_INTO_UNIT_MESSAGE: "conversion de %1 en %2",
  CONVERT_INTO_UNIT_TOOLTIP:
    "Renvoie la valeur de l'expression converti dans la nouvelle unité.",
  ///////////////////////////////////
  //BLOCKS FRACTION
  FRACTION_MESSAGE: "fraction %1 / %2",
  FRACTION_TOOLTIP:
    "Renvoie une fraction définie par son numérateur et dénominateur.",

  CONVERT_INTO_FRACTION_MESSAGE: "conversion de %1 en fraction",
  CONVERT_INTO_FRACTION_TOOLTIP: "Retourne un nombre sous forme de fraction.",

  FRACTION_NUMERATOR_DENOMINATOR_MESSAGE: "%1 de %2",
  FRACTION_NUMERATOR_DENOMINATOR_NUMERATOR: "numérateur",
  FRACTION_NUMERATOR_DENOMINATOR_DENOMINATOR: "dénominateur",
  FRACTION_NUMERATOR_DENOMINATOR_TOOLTIP:
    "Renvoie le numérateur ou le dénominateur d'une fraction.",

  SIMPLIFY_FRACTION_MESSAGE: "fraction irréductible de %1",
  SIMPLIFY_FRACTION_TOOLTIP: "Renvoie une fraction sous sa forme irréductible.",

  //MATH MATRIX
  //TABLE_DATA
  DATA_TABLE_TITLE: "tableau de données",
  DATA_TABLE_TOOLTIP:
    "Renvoie un tableau au format matrice constitué à partir des valeurs définies",

  //NUMPRY MATRIX (disable)
  NUMPY_SQUARE_MATRIX_TITLE: "matrice",
  MATRIX_TABLE_TOOLTIP:
    "Renvoie une matrice constituée à partir des valeurs définies",
  //MATRIX
  MATRIX_MESSAGE: "créer une matrice avec %1 %2",
  MATRIX_TOOLTIP:
    "Renvoie une matrice construite à partir du texte [[1,2],[3,4]] ou d'une liste déjà définie.",
  //MATRIX3PARAMS (MATRIX_RANDOM)
  MATRIX3PARAMS_MESSAGE:
    "créer une matrice de %1 lignes et %2 de colonnes remplie avec %3",
  MATRIX3PARAMS_TOOLTIP: `Renvoie une matrice de la taille définie et remplie avec une valeur particulière ou avec le résultat d'un calcul.`,
  //MATRIXDETERMINANT
  MATRIXDETERMINANT_MESSAGE: "déterminant de la matrice %1",
  MATRIXDETERMINANT_TOOLTIP: "Renvoie le déterminant de la matrice.",
  //MATRIX_SUM
  MATRIX_SUM_MESSAGE: "somme d'une matrice %1 et de la matrice %2",
  MATRIX_SUM_TOOLTIP: "Renvoie l'addition des deux matrices.",
  //MATRIX_MULTIPLICATION
  MATRIX_MULTIPLICATION_MESSAGE:
    "produit matriciel de la matrice %1 avec la matrice %2",
  MATRIX_MULTIPLICATION_TOOLTIP:
    "Renvoie le produit matriciel de deux matrices.",
  //MATRIX_SCALAR
  MATRIX_SCALAR_MESSAGE: "produit(scalaire) du nombre %1 et de la matrice %2",
  MATRIX_SCALAR_TOOLTIP: "Renvoie le produit entre un scalaire et une matrice.",
  //MATRIX_SHORT_SET
  MATRIX_SHORT_SET_MESSAGE: "%1[%2,%3]=%4",
  MATRIX_SHORT_SET_TOOLTIP: "Définit l'élément d'une matrice à l'index i,j",
  //MATRIX_SHORT_GET
  MATRIX_SHORT_GET_MESSAGE: "%1[%2,%3]",
  MATRIX_SHORT_GET_TOOLTIP: "Renvoie l'élément d'une matrice à l'index i,j",
  //////////////////LISTS
  //RANDOMLIST
  RANDOMLIST_MESSAGE: "créer une liste de longueur %1 et remplie avec %2",
  RANDOMLIST_TOOLTIP: `Renvoie une liste de la taille définie et remplie avec une valeur particulière ou avec le résultat d'un calcul.`,
  //LISTSSHUFFLE
  SHUFFLELIST_MESSAGE: "🎲 Mélanger aléatoirement les éléments de la liste %1",
  SHUFFLELIST_TOOLTIP:
    "Contient la liste dans laquelle les éléments seront mélangés.",
  //BLOCK DELETE_DUPLICATE
  DELETE_DUPLICATES_MESSAGE: "Supprimer les doublons dans la liste %1",
  DELETE_DUPLICATES_TOOLTIP: "Supprime les doublons dans la liste.",
  //BLOCK DELETE_ELEMENT_FROM_LIST
  DELETE_ELEMENT_FROM_LIST_MESSAGE: "supprimer l'élément %1 dans la liste %2",
  DELETE_ELEMENT_FROM_LIST_TOOLTIP: "Supprimer un élément dans une liste.",
  //BLOCK COUNT_SAME_ELEMENT_LIST
  COUNT_SAME_ELEMENT_LIST_MESSAGE:
    "compte le nombre d'occurences de %1 dans la liste %2",
  COUNT_SAME_ELEMENT_LIST_TOOLTIP:
    "Renvoie le nombre d'occurences d'un élément dans une liste.",
  //LIST_SHORT_SET
  LIST_SHORT_SET_MESSAGE: "%1[%2]=%3",
  LIST_SHORT_SET_TOOLTIP: "Définit l'élément d'une liste à l'index i.",
  //LIST_SHORT_GET
  LIST_SHORT_GET_MESSAGE: "%1[%2]",
  LIST_SHORT_GET_TOOLTIP: "Renvoie l'élément d'une liste à l'index i.",

  //CATMEDIA
  //BLOCK ELEDA_IMAGE
  IMAGE_MESSAGE: "🏞 image %1 URL %2 légende %3 %4options",
  IMAGE_WIDTH: "Largeur",
  IMAGE_HEIGHT: "Hauteur",
  IMAGE_TOOLTIP: `Affiche une image à l'aide d'un lien.
    - URL : il contient l'adresse ou le lien de l'image.`,

  IMAGE_DOCUMENTATION: `Affiche une image à l'aide d'un lien.
    - URL : il contient l'adresse ou le lien de l'image
  
    Options :
    - Largeur : permet de définir une largeur fixe pour l'image.
    - Hauteur : permet de définir une hauteur fixe pour l'image.`,

  //BLOCK ELEDA_VIDEO
  VIDEO_MESSAGE: "📽 video %1 Code d'intégration %2 légende %3",
  VIDEO_TOOLTIP: `Affiche une vidéo à l'aide d'un code d'intégration.
    - Code d'intégration : il contient le code d'intégration de la vidéo (clique droit sur une vidéo, puis copier le code d'intégration).`,

  //BLOCK ELEDA AUDIO
  ELEDA_AUDIO_MESSAGE:
    "♬ audio %1 nombre de répétition %2 Lien (mp3, mp4...) %3 légende %4",

  //BLOCK TABLE (HTML) MATRIX
  TABLE_MATRIX_TITLE: "tableau",
  GRID_MATRIX_TITLE: "grille",
  TABLE_MATRIX_TOOLTIP: "Créer un tableau HTML à partir des éléments saisies",

  //BLOCK TABLE (HTML) COLUMN
  TABLE_COLUMN_TITLE: "colonne(s)",
  TABLE_COLUMN_TOOLTIP:
    "Créer une colunne qui va générer des cellules pour le tableau",

  TEXT_JOIN_TITLE: "créer un texte avec",
  TEXT_JOIN_HELPURL: "",
  TEXT_JOIN_TOOLTIP: "",

  //block eleda_alignment
  ELEDA_ALIGNMENT_TEXT: "alignement",

  //CLONE
  CLONE_MESSAGE: "clone de %1",

  //Backpack
  EMPTY_BACKPACK: "Vide",
  REMOVE_FROM_BACKPACK: "Supprimer du sac à dos",
  COPY_TO_BACKPACK: "Copier vers le sac à dos",
  COPY_ALL_TO_BACKPACK: "Copier tous les blocs vers le sac à dos",
  PASTE_ALL_FROM_BACKPACK: "Coller tous les blocs dans l'espace de travail",

  //TEXT_CHANGECASE
  TEXT_CHANGECASE_OPERATOR_FIRSTLETTERCASE:
    "en Capitale initiale pour le premier mot",

  //Dictionary
  DICTIONARY_TITLE: "Dictionnaire",
  DICTIONARY_MESSAGE: "dictionnaire %1 %2",
  DICTIONARY_HELPURL: "",
  DICTIONARY_TOOLTIP: "",

  //random_verb
  RANDOM_VERB_TITLE: "Verbe Aléatoire",
  RANDOM_VERB_MESSAGE: "🎲 verbe aléatoire du dictionnaire %1 %2 du %3 groupe",
  RANDOM_VERB_HELPURL: "",
  RANDOM_VERB_TOOLTIP: "",

  //selected verb
  SELECTED_VERB_TITLE: "Verbe",
  SELECTED_VERB_MESSAGE:
    "verbe du dictionnaire %1 %2 %3 ayant pour infinitif %4",
  SELECTED_VERB_HELPURL: "",
  SELECTED_VERB_TOOLTIP: "",

  //verb_getAttribute
  VERB_GETATTRIBUTE_TITLE: "Obtenir l'attribut d'un verbe",
  VERB_GETATTRIBUTE_MESSAGE: "obtenir le %1 du verbe %2",
  VERB_GETATTRIBUTE_HELPURL: "",
  VERB_GETATTRIBUTE_TOOLTIP: "",

  //conjugate_verb
  CONJUGATE_VERB_TITLE: "Obtenir les conjugaisons d'un verb",
  CONJUGATE_VERB_MESSAGE:
    "obtenir les conjugaisons du verbe %1 au %2 du dictionnaire %3",
  CONJUGATE_VERB_HELPURL: "",
  CONJUGATE_VERB_TOOLTIP: "",

  //selected_determinantDefInfDemons
  SELECTED_DETERMINANTDEFINFFEMONS_TITLE: "Determinant in/defini d'un nom",
  SELECTED_DETERMINANTDEFINFFEMONS_MESSAGE:
    "determinant du dictionnaire %1 %2 de type %3 pour le nom %4",
  SELECTED_DETERMINANTDEFINFFEMONS_HELPURL: "",
  SELECTED_DETERMINANTDEFINFFEMONS_TOOLTIP: "",

  //determinantDefInfDemons_getAttribute
  DETERMINANTDEFINFDEMONS_GETATTRIBUTE_TITLE:
    "Obtenir un attribut d'un determinant",
  DETERMINANTDEFINFDEMONS_GETATTRIBUTE_MESSAGE:
    "obtenir le %1 du déterminant (in)défini ou démonstratif %2",
  DETERMINANTDEFINFDEMONS_GETATTRIBUTE_HELPURL: "",
  DETERMINANTDEFINFDEMONS_GETATTRIBUTE_TOOLTIP: "",

  //selected_determinantPoss
  SELECTED_DETERMINANTPOSS_TITLE: "Determinant possessif d'un nom",
  SELECTED_DETERMINANTPOSS_MESSAGE:
    "determinant possessif du dictionnaire %1 %2 pour le nom %3",
  SELECTED_DETERMINANTPOSS_HELPURL: "",
  SELECTED_DETERMINANTPOSS_TOOLTIP: "",

  //determinantPoss_getListForNumber
  DETERMINANTPOSS_GETLISTFORNUMBER_TITLE: "Liste des déterminants possessif",
  DETERMINANTPOSS_GETLISTFORNUMBER_MESSAGE:
    "obtenir la liste au %1 du déterminant possessif %2",
  DETERMINANTPOSS_GETLISTFORNUMBER_HELPURL: "",
  DETERMINANTPOSS_GETLISTFORNUMBER_TOOLTIP: "",

  //random_name
  RANDOM_NAME_TITLE: "Nom aléatoire",
  RANDOM_NAME_MESSAGE:
    "🎲 nom aléatoire du dictionnaire %1 %2 ayant pour genre %3",
  RANDOM_NAME_HELPURL: "",
  RANDOM_NAME_TOOLTIP: "",

  //selected_name
  SELECTED_NAME_TITLE: "Nom",
  SELECTED_NAME_MESSAGE: "nom du dictionnaire %1 %2 ayant pour intitulé %3",
  SELECTED_NAME_HELPURL: "",
  SELECTED_NAME_TOOLTIP: "",

  //name_getAttribute
  NAME_GETATTRIBUTE_TITLE: "Obtenir l'attribut d'un nom",
  NAME_GETATTRIBUTE_MESSAGE: "obtenir le %1 du nom %2",
  NAME_GETATTRIBUTE_HELPURL: "",
  NAME_GETATTRIBUTE_TOOLTIP: "",

  //random_adjective
  RANDOM_ADJECTIVE_TITLE: "Adjectif aléatoire",
  RANDOM_ADJECTIVE_MESSAGE: "🎲 adjectif aléatoire du dictionnaire %1",
  RANDOM_ADJECTIVE_HELPURL: "",
  RANDOM_ADJECTIVE_TOOLTIP: "",

  //selected_adjective
  SELECTED_ADJECTIVE_TITLE: "Adjectif",
  SELECTED_ADJECTIVE_MESSAGE:
    "adjectif du dictionnaire %1 %2 ayant pour intitulé %3",
  SELECTED_ADJECTIVE_HELPURL: "",
  SELECTED_ADJECTIVE_TOOLTIP: "",

  //adjective_getAttribute
  ADJECTIVE_GETATTRIBUTE_TITLE: "Obtenir l'attribut d'un adjectif",
  ADJECTIVE_GETATTRIBUTE_MESSAGE: "obtenir le %1 de l'adjectif %2",
  ADJECTIVE_GETATTRIBUTE_HELPURL: "",
  ADJECTIVE_GETATTRIBUTE_TOOLTIP: "",

  //split_into_words_letters
  SPLIT_INTO_WORDS_LETTERS_TITLE: "Découper le texte",
  SPLIT_INTO_WORDS_LETTERS_MESSAGE: "découper le texte %1 %2 en  %3",
  SPLIT_INTO_WORDS_LETTERS_HELPURL: "",
  SPLIT_INTO_WORDS_LETTERS_TOOLTIP: "",

  //french words
  MALE: "masculin",
  FEMALE: "feminin",
  SINGULAR: "singulier",
  PLURAL: "pluriel",
  RANDOM: "aléatoire",
  GENDER: "genre",
  NUMBER: "nombre",
  WORDS: "mots",
  LETTERS: "lettres",

  //LOGIC CATEGORY (ADD DOC TO BLOCKLY EXISTING BLOCKS)
  LOGIC_COMPARE_DOCUMENTATION:
    "Renvoyer vrai si les deux entrées sont égales. = and ≠ peuvent être utilisés pour également comparer des objets géométriques.",
};
